<template>
  <v-form v-model="valid" ref="mainForm">
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="auMoinsUnOrdreSelectionne"
      :rules="[(v) => !!v || 'Vous devez choisir au moins un ordre professionnel']"
    ></v-checkbox>
    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-inf" v-model="sasPermisPsychotherapeute.ordreInfirmiers" :live="liveSasPsychotherapeute(4603)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreInfirmiers"
        code="ordre-inf-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreInfirmiers"
        :live="liveSasPsychotherapeute(4604)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreInfirmiers"
        code="ordre-inf-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreInfirmier"
        :live="liveSasPsychotherapeute(4605)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-co" v-model="sasPermisPsychotherapeute.ordreConseillers" :live="liveSasPsychotherapeute(4606)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreConseillers"
        code="ordre-co-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreConseillers"
        :live="liveSasPsychotherapeute(4607)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreConseillers"
        code="ordre-co-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreConseillers"
        :live="liveSasPsychotherapeute(4608)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-tcf" v-model="sasPermisPsychotherapeute.ordreTCF" :live="liveSasPsychotherapeute(4612)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreTCF"
        code="ordre-tcf-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreTCF"
        :live="liveSasPsychotherapeute(4613)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreTCF"
        code="ordre-tcf-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreTCF"
        :live="liveSasPsychotherapeute(4614)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-ts" v-model="sasPermisPsychotherapeute.ordreTS" :live="liveSasPsychotherapeute(4609)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreTS"
        code="ordre-ts-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreTS"
        :live="liveSasPsychotherapeute(4610)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreTS"
        code="ordre-ts-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreTS"
        :live="liveSasPsychotherapeute(4611)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-erg" v-model="sasPermisPsychotherapeute.ordreErgo" :live="liveSasPsychotherapeute(4615)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreErgo"
        code="ordre-erg-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreErgo"
        :live="liveSasPsychotherapeute(4616)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreErgo"
        code="ordre-erg-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreErgo"
        :live="liveSasPsychotherapeute(4617)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-psyed" v-model="sasPermisPsychotherapeute.ordrePsyEd" :live="liveSasPsychotherapeute(4618)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordrePsyEd"
        code="ordre-psyed-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdrePsyEd"
        :live="liveSasPsychotherapeute(4619)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordrePsyEd"
        code="ordre-psyed-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdrePsyEd"
        :live="liveSasPsychotherapeute(4620)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-sexo" v-model="sasPermisPsychotherapeute.ordreSexologues" :live="liveSasPsychotherapeute(4621)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreSexologues"
        code="ordre-sexo-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreSexologues"
        :live="liveSasPsychotherapeute(4622)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreSexologues"
        code="ordre-sexo-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreSexologues"
        :live="liveSasPsychotherapeute(4623)"
        optional
      ></opq-file>
    </v-card>

    <v-card class="pa-3 mb-3" outlined max-width="500">
      <opq-case code="ordre-crim" v-model="sasPermisPsychotherapeute.ordreCriminologues" :live="liveSasPsychotherapeute(4624)" optional> </opq-case>
      <opq-text-field
        :opq-if="sasPermisPsychotherapeute.ordreCriminologues"
        code="ordre-crim-permis"
        v-model="sasPermisPsychotherapeute.numeroPermisOrdreCriminologues"
        :live="liveSasPsychotherapeute(4625)"
        optional
      >
      </opq-text-field>
      <opq-file
        :opq-if="sasPermisPsychotherapeute.ordreCriminologues"
        code="ordre-crim-carte"
        :file="sasPermisPsychotherapeute.carteMembreOrdreCriminologues"
        :live="liveSasPsychotherapeute(4626)"
        optional
      ></opq-file>
    </v-card>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
export default {
  mixins: [CataloguesHelper, FormSimple],
  components: { AdressePersonnelle },
  props: {
    sas: { type: Object }
  },

  methods: {
    liveSasPsychotherapeute(cle) {
      return { endpoint: "sas-permis-psychotherapeute", cle: cle, fileId: this.sasPermisPsychotherapeute.id }
    }
  },

  computed: {
    sasPermisPsychotherapeute() {
      return this.sas.sasPermisPsychotherapeute
    },
    auMoinsUnOrdreSelectionne() {
      return (
        this.sasPermisPsychotherapeute.ordreInfirmiers ||
        this.sasPermisPsychotherapeute.ordreConseillers ||
        this.sasPermisPsychotherapeute.ordreTCF ||
        this.sasPermisPsychotherapeute.ordreTS ||
        this.sasPermisPsychotherapeute.ordreErgo ||
        this.sasPermisPsychotherapeute.ordrePsyEd ||
        this.sasPermisPsychotherapeute.ordreSexologues ||
        this.sasPermisPsychotherapeute.ordreCriminologues
      )
    }
  }
}
</script>

<style>
</style>